import * as React from "react"
import { SVGProps } from "react"

const PopupIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 6.33333L17 1M17 1H11.6667M17 1L9.88889 8.11111M7.22222 2.77778H5.26667C3.77319 2.77778 3.02646 2.77778 2.45603 3.06843C1.95426 3.32409 1.54631 3.73204 1.29065 4.2338C1 4.80423 1 5.55097 1 7.04444V12.7333C1 14.2268 1 14.9735 1.29065 15.544C1.54631 16.0457 1.95426 16.4537 2.45603 16.7094C3.02646 17 3.77319 17 5.26667 17H10.9556C12.449 17 13.1958 17 13.7662 16.7094C14.268 16.4537 14.6759 16.0457 14.9316 15.544C15.2222 14.9735 15.2222 14.2268 15.2222 12.7333V10.7778" stroke="#0F9764" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default React.memo(PopupIcon);